import { FormEvent, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { useHistory } from "react-router-dom";
import Button from "../../components/Button";
import IconButton from "../../components/IconButton";
import InputSelect from "../../components/Input-select";
import Title from "../../components/Title";
import { toastError, toastSuccess, toastWarn } from "../../components/Toast";
import useAuthData from "../../hook/useAppData";
import { IconLeftArrowVersion2 } from "../../icons";
import { getProfiles } from "../Profile/service";
import { getRoleInProject } from "../RoleInProject/service";
import { getJobSetting, postJobSetting } from "./service";

export const JobSettings = (): JSX.Element => {
  const { token } = useAuthData();
  const [valuesOfScreen, setValuesOfScreen] = useState({ excess: 0, missing: 0, approve: 0 });
  const [roleInProject, setRoleInProject] = useState<{ id: number; name: string }[]>();
  const [profilesList, setProfilesList] = useState<{ id: number; name: string }[]>();

  const history = useHistory();

  useEffect(() => {
    findListData();
    findJobSettings();
  }, []);

  const findListData = async () => {
    const [roleInProject, profilesList] = await Promise.all([getRoleInProject({ token }), getProfiles(token)]);
    setRoleInProject(roleInProject);
    setProfilesList(profilesList);
  };

  const findJobSettings = async () => {
    const jobSettings = await getJobSetting({ token });
    const missing = jobSettings?.find((item) => item?.notificade === "missing")?.idNotify || 0;
    const excess = jobSettings?.find((item) => item?.notificade === "excess")?.idNotify || 0;
    const approve = jobSettings?.find((item) => item?.notificade === "approve")?.idNotify || 0;
    setValuesOfScreen({ missing, excess, approve });
  };

  const handleSubmitForm = async (event: FormEvent) => {
    event.preventDefault();
    if (verefyIfAllHasNotOk()) return toastError("Preencha todos os campos");
    const [resSaveMissing, resSaveExcess, resSaveApprove] = await Promise.all([saveMissing(), saveExcess(), saveApprove()]);
    if (!resSaveMissing?.ok || !resSaveExcess?.ok || !resSaveApprove?.ok) return toastError(`Não foi possivel salvar as configurações`);
    toastSuccess("Configuração para notificações salva com sucesso!");
    setTimeout(() => {
      exit();
    }, 2000);
  };

  const saveMissing = async () => {
    if (!valuesOfScreen.missing) {
      toastWarn("Nehum perfil selecionado para notificação para quando horas estiverem abaixo do limite");
      return { ok: true };
    }
    return await postJobSetting({ body: { idNotify: valuesOfScreen.missing, notificade: "missing" }, token });
  };

  const saveExcess = async () => {
    if (!valuesOfScreen.excess) {
      toastWarn("Nehum perfil selecionado para notificação para quando horas estiverem acima do limite");
      return { ok: true };
    }
    return await postJobSetting({ body: { idNotify: valuesOfScreen.excess, notificade: "excess" }, token });
  };

  const saveApprove = async () => {
    if (!valuesOfScreen.approve) {
      toastWarn("Nehum cargo de projeto selecionado para ser notificado para quando tiver horas para aprovar");
      return { ok: true };
    }
    return await postJobSetting({ body: { idNotify: valuesOfScreen.approve, notificade: "approve" }, token });
  };

  const verefyIfAllHasNotOk = () => {
    if (!valuesOfScreen?.missing || !valuesOfScreen?.excess) return true;
    return false;
  };

  const exit = () => history.goBack();

  return (
    <>
      <Toaster />
      <div className="container font-familyPoppins text-textPrimary text-1.4rem flex flex-col gap-12">
        <Title
          title={
            <>
              <IconButton className="text-textPrimary" onClick={exit} icon={IconLeftArrowVersion2} />
              Configuração da Rotina Semanal
            </>
          }
        />
        <form onSubmit={handleSubmitForm} className="box-form p-8 justify-around">
          <div className="w-full flex flex-row justify-between items-center h-52">
            <p className="text-2xl text-left w-3/4">
              Qual função dentro de um projeto tem de ser notificado quando tiver horas para serem{" "}
              <strong className="underline text-1.6rem">aprovadas</strong>?
            </p>
            <InputSelect
              className="w-1/4"
              name="approve"
              label=""
              placeholder="Selecione uma função"
              onChange={(e) => {
                setValuesOfScreen({ ...valuesOfScreen, approve: +e.target.value });
              }}
              value={valuesOfScreen.approve}
              list={roleInProject}
            />
          </div>
          <div className="w-full flex flex-row justify-between items-center h-52">
            <p className="text-2xl text-left w-3/4">
              Qual função dentro de um projeto tem de ser notificado quando um profissional estiver com horas{" "}
              <strong className="underline text-1.6rem">excedentes</strong> ao permitido?
            </p>
            <InputSelect
              className="w-1/4"
              name="excess"
              label=""
              placeholder="Selecione uma função"
              onChange={(e) => {
                setValuesOfScreen({ ...valuesOfScreen, excess: +e.target.value });
              }}
              value={valuesOfScreen.excess}
              list={roleInProject}
            />
          </div>
          <div className="w-full flex flex-row justify-between items-center h-52">
            <p className="text-2xl text-left w-3/4">
              Qual função dentro de um projeto tem de ser notificado quando um profissional estiver com horas{" "}
              <strong className="underline text-1.6rem">abaixo</strong> ao permitido?
            </p>
            <InputSelect
              className="w-1/4"
              name="missing"
              label=""
              placeholder="Selecione uma função"
              onChange={(e) => {
                setValuesOfScreen({ ...valuesOfScreen, missing: +e.target.value });
              }}
              value={valuesOfScreen.missing}
              list={profilesList}
            />
          </div>
          <div className="flex justify-end w-full gap-6">
            <Button onClick={exit} type="button" className="bg-blue-100 border border-primary text-primary">
              Cancelar
            </Button>
            <Button type="submit" className="bg-primary">
              Salvar
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};
